module.exports = __webpack_public_path__ + "988987ebcc319df493bc0d13321b356a.svg";